import { Action } from '../types/action';
import { Question } from '../types/question';
import { UserInputAction } from '../types/user-input-action';

export type AskQuestion<TId extends string> = <TAnswerType>(ask: {
  before?: Array<Action>;
  getUserInput: UserInputAction<TAnswerType>;
}) => {
  respond: (
    response: Omit<Question<TAnswerType, TId>, 'before' | 'getUserInput'>
  ) => Question<TAnswerType, TId>;
};

export const createAskQuestion =
  <TId extends string>(): AskQuestion<TId> =>
  (ask) => ({
    respond: (response) => ({
      ...ask,
      ...response,
    }),
  });
